if (!customElements.get('lite-youtube')) {
  class LiteYoutube extends HTMLElement {
    connectedCallback() {
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
      const title = this.dataset.videoTitle || 'YouTube video';
      this.setAttribute('aria-label', title);

      this.addEventListener('click', this.load.bind(this), { once: true });
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    onKeydown(event) {
      if (event.code === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        this.load();
      }
    }

    load() {
      if (this.classList.contains('is-loaded')) return;

      const videoId = this.dataset.videoId;
      const title = this.dataset.videoTitle || 'YouTube video';
      const iframe = document.createElement('iframe');

      iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`);
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', title);
      iframe.setAttribute('frameborder', '0');

      this.removeAttribute('role');
      this.removeAttribute('tabindex');
      this.removeAttribute('aria-label');
      this.textContent = '';
      this.appendChild(iframe);
      this.classList.add('is-loaded');
    }
  }

  customElements.define('lite-youtube', LiteYoutube);
}
